import {
  guardBackendStatus,
  IczRoutes,
  NetworkUnavailablePageComponent,
  NotFoundPageComponent,
  WaitingToBeComponent
} from '@icz/angular-application-core';
import {STATIC_ENVIRONMENT} from '../environments/environment';
import {
  ApplicationUnavailablePageComponent,
  LazyModuleOutletComponent,
  LoginPageComponent,
  ModuleUnavailablePageComponent,
  PlaceSelectionPageComponent,
} from '|shared';
import {ApplicationRoute, DocumentsRoute, guardUserAuthenticated} from '|ui-essl-core';


export const APP_ROUTES: IczRoutes = [
  {path: '', redirectTo: STATIC_ENVIRONMENT.defaultRoute, pathMatch: 'full'},
  {path: ApplicationRoute.DOCUMENTS, redirectTo: `${ApplicationRoute.DOCUMENTS}/${DocumentsRoute.IN_PROGRESS}`, pathMatch: 'full'},
  {path: ApplicationRoute.APPLICATION_UNAVAILABLE, component: ApplicationUnavailablePageComponent, data: {skipHistoryBit: true}},
  {path: ApplicationRoute.MODULE_UNAVAILABLE, component: ModuleUnavailablePageComponent, data: {skipHistoryBit: true}},
  {path: ApplicationRoute.NETWORK_UNAVAILABLE, component: NetworkUnavailablePageComponent, data: {skipHistoryBit: true}},
  {
    path: ApplicationRoute.WAITING_TO_BE,
    component: WaitingToBeComponent,
    data: {skipHistoryBit: true}
  },
  {
    path: ApplicationRoute.LOGIN,
    canActivate: [guardBackendStatus()],
    component: LoginPageComponent,
    data: {skipHistoryBit: true},
  },
  {
    path: ApplicationRoute.PLACE_SELECT,
    canActivate: [guardUserAuthenticated(true), guardBackendStatus()],
    component: PlaceSelectionPageComponent,
    data: {skipHistoryBit: true},
  },
  {
    path: ApplicationRoute.DOCUMENTS,
    canActivate: [guardUserAuthenticated()],
    canActivateChild: [guardBackendStatus()],
    loadChildren: () => import('|feature-documents').then(m => m.DOCUMENTS_ROUTES),
  },
  {
    path: ApplicationRoute.FILING_OFFICE,
    canActivate: [guardUserAuthenticated()],
    canActivateChild: [guardBackendStatus()],
    loadChildren: () => import('|feature-filing-office'),
  },
  {
    path: ApplicationRoute.REGISTRY_OFFICE,
    canActivate: [guardUserAuthenticated()],
    canActivateChild: [guardBackendStatus()],
    loadChildren: () => import('|feature-registry-office'),
  },
  {
    path: ApplicationRoute.RESOLUTIONS,
    canActivate: [guardUserAuthenticated()],
    canActivateChild: [guardBackendStatus()],
    loadChildren: () => import('|feature-resolutions'),
  },
  {
    path: ApplicationRoute.DISPATCH,
    canActivate: [guardUserAuthenticated()],
    canActivateChild: [guardBackendStatus()],
    loadChildren: () => import('./modules/dispatch/dispatch.routes'),
  },
  {
    path: ApplicationRoute.OFFICE_DESK,
    canActivate: [guardUserAuthenticated()],
    canActivateChild: [guardBackendStatus()],
    loadChildren: () => import('./modules/office-desk/office-desk.routes'),
  },
  {
    path: ApplicationRoute.UNIT,
    canActivate: [guardUserAuthenticated()],
    canActivateChild: [guardBackendStatus()],
    loadChildren: () => import('./modules/unit/unit.routes'),
  },
  {
    path: ApplicationRoute.SHARED_FOLDERS,
    canActivate: [guardUserAuthenticated()],
    canActivateChild: [guardBackendStatus()],
    loadChildren: () => import('./modules/shared-folders/shared-folders.routes'),
  },
  {
    path: ApplicationRoute.AGENDA_TRANSFER,
    canActivate: [guardUserAuthenticated()],
    canActivateChild: [guardBackendStatus()],
    loadChildren: () => import('./modules/agenda-transfer/agenda-transfer.routes'),
  },
  {
    path: ApplicationRoute.PUBLISHED_CONTRACTS,
    canActivate: [guardUserAuthenticated()],
    canActivateChild: [guardBackendStatus()],
    loadChildren: () => import('./modules/published-contracts/published-contracts.routes'),
  },
  {
    path: ApplicationRoute.DISPOSED_ENTITIES,
    canActivate: [guardUserAuthenticated()],
    canActivateChild: [guardBackendStatus()],
    loadChildren: () => import('./modules/disposed-entities/disposed-entities.routes'),
  },
  {
    path: ApplicationRoute.ADMIN,
    canActivate: [guardUserAuthenticated()],
    canActivateChild: [guardBackendStatus()],
    loadChildren: () => import('|feature-admin'),
  },
  {
    path: ApplicationRoute.APPLICATION_CHANGELOG,
    title: 'Novinky',
    component: LazyModuleOutletComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('|ui-essl-core').then(m => m.ApplicationChangelogTableComponent),
      }
    ],
  },
  {
    path: ApplicationRoute.DEMO,
    loadChildren: () => import('|feature-demo'),
  },
  {
    path: '**',
    component: NotFoundPageComponent,
  },
];
